import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';

import 'flickity-imagesloaded';
import ProductCard from '../components/product-card';

export default register('featured-collections', {
  onLoad() {
    const tabContentEls = this.container.querySelectorAll('.js-tabcontent.loading');

    // Initialise tabcontents
    tabContentEls.forEach((tabcontent) => tabcontent.classList.remove('loading'));

    // Initialise sliders
    tabContentEls.forEach((panel) => {
      const panelSlider = panel.querySelector('.featured-collections__slider');
      const thisPreviousButton = panel.querySelector('.btn--control-prev');
      const thisNextButton = panel.querySelector('.btn--control-next');
      const carouselStatus = panel.querySelector('.carousel-status');

      const thisSlider = new Flickity(panelSlider, {
        // options
        freeScroll: false,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: 'left',
        watchCSS: true,
        wrapAround: false,
        on: {
          change() {
            if (!thisSlider.slides[thisSlider.selectedIndex - 1]) {
              thisPreviousButton.setAttribute('disabled', 'disabled');
              thisNextButton.removeAttribute('disabled');
              // eslint-disable-next-line no-negated-condition
            } else if (!thisSlider.slides[thisSlider.selectedIndex + 1]) {
              thisPreviousButton.removeAttribute('disabled');
              thisNextButton.setAttribute('disabled', 'disabled');
            } else {
              thisPreviousButton.removeAttribute('disabled');
              thisNextButton.removeAttribute('disabled');
            }
          },
        },
      });

      thisSlider.resize();

      function updateStatus() {
        let slideNumber = thisSlider.selectedIndex + 1;
        if (thisSlider.slides.length - 1 === slideNumber) {
          slideNumber = thisSlider.slides.length;
        }
        carouselStatus.textContent = `0${slideNumber} / ${thisSlider.slides.length < 10 ? '0' : ''}${
          thisSlider.slides.length
        }`;
      }

      updateStatus();
      thisSlider.on('select', updateStatus);

      if (thisPreviousButton) {
        thisPreviousButton.addEventListener('click', function () {
          thisSlider.previous();
        });
        thisNextButton.addEventListener('click', function () {
          thisSlider.next();
        });
      }
    });

    // Event listener when tab links are clicked
    const tablistLinks = this.container.querySelectorAll('.js-tablist__link');
    if (tablistLinks && tablistLinks.length > 0) {
      tablistLinks.forEach((link) => {
        link.addEventListener('focus', () => {
          const tabID = link.getAttribute('aria-controls');
          const tab = document.getElementById(tabID);

          // Resize and update flickity slider for each product card
          const productSliders = tab.querySelectorAll('.featured-collections__slider');
          if (productSliders && productSliders.length > 0) {
            productSliders.forEach((item) => {
              const productSlider = Flickity.data(item);
              if (productSlider) {
                productSlider.resize();
              }
            });
          }
        });

        link.addEventListener('click', () => {
          const tabID = link.getAttribute('aria-controls');
          const tab = document.getElementById(tabID);

          // Resize and update flickity slider for each product card
          const productSliders = tab.querySelectorAll('.featured-collections__slider');
          if (productSliders && productSliders.length > 0) {
            productSliders.forEach((item) => {
              const productSlider = Flickity.data(item);
              if (productSlider) {
                productSlider.resize();
              }
            });
          }
        });
      });
    }

    const productCards = this.container.querySelectorAll('.product-card');
    if (productCards && productCards.length > 0) {
      productCards.forEach((product) => ProductCard(product));
    }
  },
});
